export default __webpack_public_path__ + "static/media/reload.d6a9dc6c.svg";